import type { SVGProps } from 'react';
const SvgPlayArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#play_arrow_svg__a)">
      <path fill="currentColor" d="M8 5v14l11-7L8 5Z" />
    </g>
    <defs>
      <clipPath id="play_arrow_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgPlayArrow;
